import "./App.css";
import AllRoutes from "./Routes";
function App() {
  return (
    <div>
      <AllRoutes />
    </div>
  );
}

export default App;
